import { createContext, useContext, useState, useEffect } from "react";
import { getUserWithAuthorities } from "../services/users/usersService";

export const UserContext = createContext(null);

// Hook personalizado para acceder al contexto
export const useUser = () => useContext(UserContext);

// Proveedor del contexto
export const UserProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true); // Estado de carga

    useEffect(() => {
        const fetchUser = async () => {
            try {
                const userData = await getUserWithAuthorities();
                if (userData) setUser(userData);
            } catch (error) {
                console.error("Error obteniendo usuario:", error);
            } finally {
                setLoading(false); // Finaliza la carga
            }
        };

        fetchUser();
    }, []);

    return (
        <UserContext.Provider value={{ user, setUser, loading }}>
            {children}
        </UserContext.Provider>
    );
};